import { render, staticRenderFns } from "./ConversationArea.vue?vue&type=template&id=39e2dffc&scoped=true&"
import script from "./ConversationArea.vue?vue&type=script&lang=js&"
export * from "./ConversationArea.vue?vue&type=script&lang=js&"
import style0 from "./ConversationArea.vue?vue&type=style&index=0&id=39e2dffc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2dffc",
  null
  
)

export default component.exports